import { FRD } from "@nens/brostar/openapi-client";
import {
  EditFRDStartRegistrationTask,
  qualityRegimeOptionsType,
} from "@nens/brostar/uploadapi-client";

import { isValidEnum } from "./is-valid-enum";

// EDIT (from existing FRD object)
export const convertFRDToEditTask = ({
  broId,
  deliveryAccountableParty,
  qualityRegime,
  gmwBroId,
  tubeNumber,
  linkedGmns,
}: FRD): EditFRDStartRegistrationTask => {
  const groundwaterMonitoringNets = Array.isArray(linkedGmns) ? (linkedGmns as string[]) : [];

  return {
    metadata: {
      broId: broId,
      projectNumber: "",
      qualityRegime: isValidEnum(qualityRegimeOptionsType, qualityRegime),
      deliveryAccountableParty: deliveryAccountableParty ?? "",
      correctionReason: "eigenCorrectie",
    },
    sourcedocumentData: {
      objectIdAccountableParty: "",
      gmwBroId: gmwBroId ?? "",
      tubeNumber: tubeNumber ?? "",
      groundwaterMonitoringNets,
    },
  };
};
